module.exports = __webpack_public_path__ + "img/hand_dark.3419c310.svg";